import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { QueryService } from '../../../templates/services/query-service.template';
import { Core2Config } from '../../../utils/core2-config';
import { CMSMenuContainerModel } from '../../../models/cms/cms-menu-container.model';

@Injectable({
  providedIn: 'root'
})
export class EntityLoginSubjectLinkService extends QueryService<CMSMenuContainerModel> {

  constructor(protected readonly h: HttpClient) {
    super(Core2Config.TENANT_DOMAIN_URL_PREFIX + 'erp/entity-login-subject-links', h);
  }
}
